var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10102 2.0459H2.92765C3.08268 0.980767 3.96102 0.154297 5.01147 0.154297H12.899C14.0529 0.154297 15 1.16441 15 2.39474V8.71225C15 9.94272 14.0528 10.9527 12.899 10.9527H12.0723C11.9173 12.0178 11.039 12.8443 9.98853 12.8443H2.10102C0.947123 12.8443 0 11.8342 0 10.6039V4.28635C0 3.05588 0.94725 2.0459 2.10102 2.0459ZM12.0036 3.60687C12.0554 3.8272 12.0898 4.04768 12.0898 4.28635V10.2732H12.8992C13.7086 10.2732 14.363 9.57537 14.363 8.71221V3.6066L12.0036 3.60687ZM8.21478 3.33138C8.50752 3.33138 8.76585 3.58853 8.76585 3.91902C8.76585 4.23119 8.5075 4.48832 8.21478 4.48832C7.92204 4.48832 7.68091 4.23117 7.68091 3.91902C7.68091 3.58852 7.92205 3.33138 8.21478 3.33138ZM9.88534 3.33138C9.5926 3.33138 9.35147 3.58853 9.35147 3.91902C9.35147 4.23119 9.59262 4.48832 9.88534 4.48832C10.1953 4.48832 10.4364 4.23117 10.4364 3.91902C10.4364 3.58852 10.1953 3.33138 9.88534 3.33138ZM11.4526 5.49847H0.637096V10.6041C0.637096 11.4672 1.29149 12.165 2.10092 12.165H9.98844C10.7979 12.165 11.4523 11.4672 11.4523 10.6041V5.49847H11.4526Z",
    fill: "#092C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIcon);
export default __webpack_public_path__ + "static/media/themeIcon.7fdaf692e06daea8a2c139bccfa2499b.svg";
export { ForwardRef as ReactComponent };